import { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import Wrapper from "../../../components/UI/Wrapper";
import SearchIcon from "@mui/icons-material/Search";
import "../../OperationMasterPages/RelocationExpenseDetail/RelocationExpenseDetail.css";
import Bills from '../../../Icons/Bills.png'
import filterIcon from "../../../Icons/filterIcon.png";
import CryptoJS from "crypto-js";
import axios from "axios";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";

const ExpenseDetail = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_Id");
    const relocationId = decryptRelocationID(encryptedRelocationID);

    const [formData, setFormData] = useState({
        expense_detail_id: null,
        relocation_id: relocationId || null,
        bill_no: "",
        location: "",
        expense_date: "",
        expense_type: null,
        expense_description: null,
        vendor_id: null,
        rate: 0,
        quantity: 0,
        sale_amount: 0,
        payment_mode: "",
        payment_made_by: "",
        expense_amount: 0,
        remarks: "",
        attachment: "",
        added_date: "",
        added_by: "",
        payment_status: null,
        approved_by: "",
        expense_category: null,
        file_status: "",
    });

    const [updateData, setUpdateData] = useState({
        expense_detail_id: null,
        relocation_id: relocationId || null,
        bill_no: "",
        location: "",
        expense_date: "",
        expense_type: null,
        expense_description: null,
        vendor_id: null,
        rate: 0,
        quantity: 0,
        sale_amount: 0,
        payment_mode: "",
        payment_made_by: "",
        expense_amount: 0,
        remarks: "",
        attachment: "",
        added_date: "",
        added_by: "",
        payment_status: null,
        approved_by: "",
        expense_category: null,
        file_status: "",
    });



    // Single handleChange function to update form data


    const [expenseDetailResponse, setExpenseDetailResponse] = useState([]);
    const [relocationDetailResponse, setRelocationDetailResponse] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const baseAPI = process.env.REACT_APP_API_URL;
    const baseImageURL = process.env.REACT_APP_IMAGE_URL;
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const [expenseCategory, setExpenseCategory] = useState([]);
    const [expenseDescription, setExpenseDescription] = useState([]);
    const [expenseType, setExpenseType] = useState([]);
    const [locationDetail, setLocationDetail] = useState([]);
    const [paymentMode, setPaymentMode] = useState([]);
    const [vendorDetail, setVendorDetail] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleChangeUpdate = (e) => {
        const { name, value } = e.target;
        setUpdateData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    const handleSearchClick = (expense_detail_id) => {
        setIsModalOpen(!isModalOpen);
        fetchExpenseMasterData();

        const fetchData = async () => {
            try {
                const headers = {
                    Authorization: `Bearer ${storedToken}`, // Replace with your token logic
                    "Content-Type": "application/json",
                };

                const expenseDetailRes = await axios.get(`${baseAPI}userGet/GetExpenseDetails?expense_detail_id=${expense_detail_id}&relocation_id=${relocationId}`, { headers });
                setUpdateData(expenseDetailRes.data.data[0]);

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    };

    const CloseModal = () => {
        setIsModalOpen(false); // Close the modal when the "X" button is clicked
    };

    const navigate = useNavigate();
    const handleClick = () => {
        navigate('/Bill');
    };


    const [showForm, setShowForm] = useState(false);

    const handleAddClick = () => {
        setShowForm(true);
        fetchExpenseMasterData();

    };


    const handleCancelClick = () => {
        setShowForm(false);
    };

    const fetchExpenseMasterData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${storedToken}`,
                "Content-Type": "application/json",
            };

            const [
                expenseCategoryRes,
                expenseDescriptionRes,
                expenseTypeRes,
                locationDetailRes,
                paymentModeRes,
                vendorDetailRes
            ] = await Promise.all([
                axios.get(`${baseAPI}adminGet/GetExpenseCategories`, { headers }),
                axios.get(`${baseAPI}adminGet/GetExpenseDescriptions`, { headers }),
                axios.get(`${baseAPI}adminGet/GetExpenseTypes`, { headers }),
                axios.get(`${baseAPI}adminGet/GetLocations`, { headers }),
                axios.get(`${baseAPI}adminGet/GetPaymentMode`, { headers }),
                axios.get(`${baseAPI}adminGet/GETSupplier?SupplierID=0`, { headers }),
            ]);

            setExpenseCategory(expenseCategoryRes.data.data);
            setExpenseDescription(expenseDescriptionRes.data.data);
            setExpenseType(expenseTypeRes.data.data);
            setLocationDetail(locationDetailRes.data.data);
            setPaymentMode(paymentModeRes.data.data);
            setVendorDetail(vendorDetailRes.data.data);

        } catch (error) {
            console.error("Error fetching master data:", error);
        }
    };




    const handleSave = async (e) => {
        e.preventDefault();
        try {

            const headers = {
                Authorization: `Bearer ${storedToken}`, // Replace with your token logic
                "Content-Type": "application/json",
            };

            const response = await axios.post(`${baseAPI}UserPost/InsertUpdateCmpExpenseDetail`, formData, { headers });

            if (response.status === 200) {
                alert("Expense saved successfully!");
                setShowForm(false);
            } else {
                console.error("Unexpected response:", response);
                alert("Error saving expense!");
            }
        } catch (error) {
            console.error("Error saving expense:", error.response ? error.response.data : error.message);
            alert("Error saving expense!");
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const headers = {
                    Authorization: `Bearer ${storedToken}`, // Replace with your token logic
                    "Content-Type": "application/json",
                };
                const relocationDetailRes = await axios.get(`${baseAPI}userGet/GetRelocationdetailForEstimate?relocation_id=${relocationId}`, { headers });
                setRelocationDetailResponse(relocationDetailRes.data.data[0]);

                const expenseDetailRes = await axios.get(`${baseAPI}userGet/GetExpenseDetails?expense_detail_id=0&relocation_id=${relocationId}`, { headers });
                setExpenseDetailResponse(expenseDetailRes.data.data);

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);


    function decryptRelocationID(ciphertext) {
        try {
            const bytes = CryptoJS.AES.decrypt(
                decodeURIComponent(ciphertext),
                "dbbworldwidepvtltd"
            );
            const decrypted = bytes.toString(CryptoJS.enc.Utf8);
            return decrypted;
        } catch (error) {
            console.error("Error decrypting Relocation_ID:", error);
            return null;
        }
    }

    return (
        <div className="d-flex flex-row app">
            <MiniDrawer />
            <div
                className="container-fluid respDiv"
                style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
            >
                <div
                    className="d-flex flex-column w-100"
                    style={{ backgroundColor: "#F4F4F4" }}
                >
                    <Wrapper className="LeadDetails">
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                            <button className="filterButton">
                                <img src={filterIcon} />
                                {" "}FILTER
                            </button>
                            <div style={{ display: "flex", justifyContent: 'space-between' }} >
                                <button
                                    className="btn btn-primary"
                                    onClick={handleAddClick}
                                    style={{
                                        margin: "0",
                                        backgroundColor: "white",
                                        color: "#6A6A6A",
                                        borderColor: "#C0C6CC",
                                        whiteSpace: "nowrap",
                                        width: "auto",
                                    }}
                                >
                                    + Add Expense
                                </button>
                            </div>
                        </div>
                        <>
                            <hr />
                            {showForm && (

                                <div class="container-1">
                                    <div class="row">
                                        <div class="col-12">
                                            <h2 class="text-left" style={{ fontSize: "18px", padding: "9px 0 0 16px" }}>Add Expense</h2>
                                        </div>
                                    </div>

                                    <div class="row expense-rowms">
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Location</label>
                                            <select class="form-control form-control-expencsems" name="location" onChange={handleChange} value={formData.location} >
                                                <option>Select</option>
                                                {locationDetail.map((location) => (
                                                    <option key={location.location_id} value={location.location_id}>
                                                        {location.location}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Date of Expense</label>
                                            <input type="date" class="form-control form-control-expencsems" name="expense_date" onChange={handleChange} value={formData.expense_date} />
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Expense Type</label>
                                            <select class="form-control form-control-expencsems" name="expense_type" onChange={handleChange} value={formData.expense_type} >
                                                <option>Select</option>
                                                {expenseType.map((exp) => (
                                                    <option key={exp.expense_type_id} value={exp.expense_type_id}>
                                                        {exp.expense_type}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Bill No.</label>
                                            <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="bill_no" onChange={handleChange} value={formData.bill_no} />
                                        </div>
                                    </div>

                                    <div class="row mt-3 expense-rowms">
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Vendor (if not registered , first add a vendor)</label>
                                            <select class="form-control form-control-expencsems" name="vendor_id" onChange={handleChange} value={formData.vendor_id}>
                                                <option>Select</option>
                                                {vendorDetail.map((exp) => (
                                                    <option key={exp.Vendor_Id} value={exp.Vendor_Id}>
                                                        {exp.VendorFirstName} {exp.VendorLastName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Description</label>
                                            <select class="form-control form-control-expencsems" name="expense_description" onChange={handleChange} value={formData.expense_description}>
                                                <option>Select</option>
                                                {expenseDescription.map((exp) => (
                                                    <option key={exp.expense_description_id} value={exp.expense_description_id}>
                                                        {exp.description}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Rate</label>
                                            <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="rate" onChange={handleChange} value={formData.rate} />
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Quantity</label>
                                            <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="quantity" onChange={handleChange} value={formData.quantity} />
                                        </div>
                                    </div>

                                    <div class="row mt-3 expense-rowms">
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Sale Amount</label>
                                            <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="sale_amount" onChange={handleChange} value={formData.sale_amount} />
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Payment Mode</label>
                                            <select class="form-control form-control-expencsems" name="payment_mode" onChange={handleChange} value={formData.payment_mode}  >
                                                <option>Select</option>
                                                {paymentMode.map((exp) => (
                                                    <option key={exp.payment_mode_id} value={exp.payment_mode_id}>
                                                        {exp.payment_mode}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Payment Made By</label>
                                            <select class="form-control form-control-expencsems" name="payment_made_by" onChange={handleChange} value={formData.payment_made_by} >
                                                <option value="" >Select</option>
                                                <option value="Petty Cash Master">Petty Cash Master</option>
                                            </select>

                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Expense Amount</label>
                                            <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="expense_amount" onChange={handleChange} value={formData.expense_amount} />
                                        </div>
                                    </div>

                                    <div class="row mt-3 expense-rowms">
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Payment Status</label>
                                            <select class="form-control form-control-expencsems" name="payment_status" onChange={handleChange} value={formData.payment_status} >
                                                <option>Select</option>
                                                <option value="0">Unpaid</option>
                                                <option value="1" >Paid</option>

                                            </select>
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Expense Category</label>
                                            <select class="form-control form-control-expencsems" name="expense_category" onChange={handleChange} value={formData.expense_category}  >
                                                <option>Select</option>
                                                {expenseCategory.map((exp) => (
                                                    <option key={exp.expense_category_id} value={exp.expense_category_id}>
                                                        {exp.expense_type}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">File Status</label>
                                            <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="file_status" onChange={handleChange} value={formData.file_status} />
                                        </div>
                                        <div class="col-md-3">
                                            <label className="label-expenseMs">Choose Document</label>
                                            <input type="file" class="form-control form-control-expencsems" name="attachment" />
                                        </div>
                                    </div>

                                    <div class="row mt-3 expense-rowms">
                                        <div class="col-md-12">
                                            <label className="label-expenseMs">Remark (If Any)</label>
                                            <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="remarks" onChange={handleChange} value={formData.remarks} />
                                        </div>
                                    </div>
                                    <div class="row mt-4 text-left">
                                        <div class="col-12" style={{ textAlign: 'end' }}>
                                            <button type="button" class="btn" style={{ background: 'none', color: 'red' }} onClick={handleCancelClick}  >Cancel</button>
                                            <button type="submit" class="btn btn-primary" style={{ marginTop: "0px" }} onClick={handleSave}>Add +</button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <hr />
                            <div className="viewLeadDetails-form">
                                <table
                                    style={{
                                        width: "100%",
                                        color: "#6A6A6A",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <tr className="viewLeadDetailsHeading">
                                        <th
                                            colSpan={4}
                                            style={{
                                                background: "#5B489D",
                                                color: "white",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <span style={{ fontSize: "18px" }}>
                                                {" "}
                                                Details{" "}
                                            </span>
                                        </th>

                                    </tr>
                                    <tr className="viewLeadDetailsHeading">
                                        <th>
                                            <span>Customer Name</span>
                                        </th>
                                        <td>
                                            <span> {relocationDetailResponse.first_name}
                                            </span>
                                        </td>
                                        <th>
                                            <span>Contact Number</span>
                                        </th>
                                        <td>
                                            <span> {relocationDetailResponse.first_name} </span>
                                        </td>
                                    </tr>

                                    <tr className="viewLeadDetailsHeading">
                                        <th>
                                            <span>No. of Pet</span>
                                        </th>
                                        <td>
                                            <span> {relocationDetailResponse.Number_Of_Pets} </span>
                                        </td>
                                        <th>
                                            <span>Pet Type</span>
                                        </th>
                                        <td>
                                            <span> {relocationDetailResponse.pettype}</span>
                                        </td>
                                    </tr>

                                    <tr className="viewLeadDetailsHeading">
                                        <th>
                                            <span>Pet Name & Breed</span>
                                        </th>
                                        <td>
                                            <span>{relocationDetailResponse.petbreedtype}</span>
                                        </td>
                                        <th>
                                            <span>Pet Dimensions & Crate </span>
                                        </th>
                                        <td>
                                            <span> {relocationDetailResponse.crate_size} </span>
                                        </td>
                                    </tr>

                                    <tr className="viewLeadDetailsHeading">
                                        <th>
                                            <span>Origin</span>
                                        </th>
                                        <td>
                                            <span> {relocationDetailResponse.origin_city}</span>
                                        </td>
                                        <th>
                                            <span>Destination</span>
                                        </th>
                                        <td>
                                            <span>{relocationDetailResponse.destination_city}</span>
                                        </td>
                                    </tr>
                                    <tr className="viewLeadDetailsHeading">
                                        <th>
                                            <span>Sales Co-ordinator</span>
                                        </th>
                                        <td>
                                            <span>  {relocationDetailResponse.assigned_to_name} </span>
                                        </td>
                                        <th>
                                            <span>Operation Co-ordinator</span>
                                        </th>
                                        <td>
                                            <span> {relocationDetailResponse.Coordinator}  </span>
                                        </td>
                                    </tr>
                                    <tr className="viewLeadDetailsHeading">
                                        <th>
                                            <span>Field Co-ordinator</span>
                                        </th>
                                        <td>
                                            <span>  {relocationDetailResponse.Field_Ops}  </span>
                                        </td>
                                        <th>
                                            <span></span>
                                        </th>
                                        <td>
                                            <span></span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div className="container-fluid px-0">
                                <div className="expenseList">
                                    <h2
                                        className="Venderheading"
                                        style={{
                                            fontSize: "22px",
                                            paddingLeft: "16px",
                                            paddingTop: "7px",
                                        }}
                                    >
                                        Expense List
                                    </h2>
                                    <table style={{ width: "100%" }} className="table_expense">
                                        <thead>
                                            <tr className="expenseListHeading">
                                                <th>S.No.</th>
                                                <th>Date </th>
                                                <th>Bill No. </th>
                                                <th>Job Type or SOW </th>
                                                <th>Qty. </th>
                                                <th>Vendor Name </th>
                                                <th>Payment Mode </th>
                                                <th>Payment Made by </th>
                                                <th>Payment Status </th>
                                                <th>Expense Category</th>
                                                <th>Sale Amount</th>
                                                <th>Expense Amount</th>
                                                <th>Action </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {expenseDetailResponse !== null ? (
                                                expenseDetailResponse.map((expense, index) => (
                                                    <tr key={index + 1}>
                                                        <td>{index + 1}</td>
                                                        <td>{expense.expense_date} </td>
                                                        <td>{expense.bill_no}</td>
                                                        <td>{expense.description}</td>
                                                        <td>{expense.quantity}</td>
                                                        <td>{expense.vendor_name}</td>
                                                        <td>{expense.payment_mode_name}</td>
                                                        <td>{expense.payment_made_by}</td>
                                                        <td>
                                                            <span style={{
                                                                backgroundColor: expense.payment_status_name === 'Paid' ? 'green' : 'orange',
                                                                color: 'white',
                                                                padding: '5px',
                                                                textAlign: 'center',
                                                            }}
                                                            >
                                                                {expense.payment_status_name}
                                                            </span>
                                                        </td>
                                                        <td>{expense.expense_category_name}</td>
                                                        <td>{expense.sale_amount}</td>
                                                        <td>{expense.expense_amount}</td>
                                                        <td style={{ textAlign: "center" }}>
                                                            <button onClick={() => handleSearchClick(expense.expense_detail_id)} className="text-center" style={{
                                                                border: "none",
                                                                width: "37px",
                                                                padding: "0px",
                                                                height: "36px",
                                                                margin: '6px',
                                                                backgroundColor: "#F1F1F1", color: "#6a6a6a", border: "none",
                                                            }} >
                                                                <SearchIcon />
                                                            </button> </td>
                                                    </tr>

                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="15">No expenses available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="text-end">

                                    </div>
                                </div>
                            </div>

                            {/* search Icon div  */}

                            {isModalOpen && (
                                <div className="modal expense-detail-model">
                                    <div className="modal-content">
                                        <div className="div-ms-item-4">
                                            <button className="item-4" onClick={CloseModal}>

                                            </button>
                                        </div>
                                        <div class="container-1">
                                            <div class="row">
                                                <div class="col-12">
                                                    <h2 class="text-left" style={{ fontSize: "18px", padding: "9px 0 0 16px" }}>Add Expense</h2>
                                                </div>
                                            </div>

                                            <div class="row expense-rowms">
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Location</label>
                                                    <select class="form-control form-control-expencsems" name="location" onChange={handleChangeUpdate} value={updateData.location} >
                                                        <option>Select</option>
                                                        {locationDetail.map((location) => (
                                                            <option key={location.location_id} value={location.location_id}>
                                                                {location.location}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Date of Expense</label>
                                                    <input type="date" class="form-control form-control-expencsems" name="expense_date" onChange={handleChangeUpdate} value={updateData.expense_date} />
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Expense Type</label>
                                                    <select class="form-control form-control-expencsems" name="expense_type" onChange={handleChangeUpdate} value={updateData.expense_type} >
                                                        <option>Select</option>
                                                        {expenseType.map((exp) => (
                                                            <option key={exp.expense_type_id} value={exp.expense_type_id}>
                                                                {exp.expense_type}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Bill No.</label>
                                                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="bill_no" onChange={handleChangeUpdate} value={updateData.bill_no} />
                                                </div>
                                            </div>

                                            <div class="row mt-3 expense-rowms">
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Vendor (if not registered , first add a vendor)</label>
                                                    <select class="form-control form-control-expencsems" name="vendor_id" onChange={handleChangeUpdate} value={updateData.vendor_id}>
                                                        <option>Select</option>
                                                        {vendorDetail.map((exp) => (
                                                            <option key={exp.Vendor_Id} value={exp.Vendor_Id}>
                                                                {exp.VendorFirstName} {exp.VendorLastName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Description</label>
                                                    <select class="form-control form-control-expencsems" name="expense_description" onChange={handleChangeUpdate} value={updateData.expense_description}>
                                                        <option>Select</option>
                                                        {expenseDescription.map((exp) => (
                                                            <option key={exp.expense_description_id} value={exp.expense_description_id}>
                                                                {exp.description}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Rate</label>
                                                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="rate" onChange={handleChangeUpdate} value={updateData.rate} />
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Quantity</label>
                                                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="quantity" onChange={handleChangeUpdate} value={updateData.quantity} />
                                                </div>
                                            </div>

                                            <div class="row mt-3 expense-rowms">
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Sale Amount</label>
                                                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="sale_amount" onChange={handleChangeUpdate} value={updateData.sale_amount} />
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Payment Mode</label>
                                                    <select class="form-control form-control-expencsems" name="payment_mode" onChange={handleChangeUpdate} value={updateData.payment_mode}  >
                                                        <option>Select</option>
                                                        {paymentMode.map((exp) => (
                                                            <option key={exp.payment_mode_id} value={exp.payment_mode_id}>
                                                                {exp.payment_mode}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Payment Made By</label>
                                                    <select class="form-control form-control-expencsems" name="payment_made_by" onChange={handleChangeUpdate} value={updateData.payment_made_by} >
                                                        <option value="" >Select</option>
                                                        <option value="Petty Cash Master">Petty Cash Master</option>
                                                    </select>

                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Expense Amount</label>
                                                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="expense_amount" onChange={handleChangeUpdate} value={updateData.expense_amount} />
                                                </div>
                                            </div>

                                            <div class="row mt-3 expense-rowms">
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Payment Status</label>
                                                    <select class="form-control form-control-expencsems" name="payment_status" onChange={handleChangeUpdate} value={updateData.payment_status} >
                                                        <option>Select</option>
                                                        <option value="0">Unpaid</option>
                                                        <option value="1" >Paid</option>

                                                    </select>
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Expense Category</label>
                                                    <select class="form-control form-control-expencsems" name="expense_category" onChange={handleChangeUpdate} value={updateData.expense_category}  >
                                                        <option>Select</option>
                                                        {expenseCategory.map((exp) => (
                                                            <option key={exp.expense_category_id} value={exp.expense_category_id}>
                                                                {exp.expense_type}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">File Status</label>
                                                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="file_status" onChange={handleChangeUpdate} value={updateData.file_status} />
                                                </div>
                                                <div class="col-md-3">
                                                    <label className="label-expenseMs">Choose Document</label>
                                                    <input type="file" class="form-control form-control-expencsems" name="attachment" />
                                                </div>
                                            </div>

                                            <div class="row mt-3 expense-rowms">
                                                <div class="col-md-12">
                                                    <label className="label-expenseMs">Remark (If Any)</label>
                                                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="remarks" onChange={handleChangeUpdate} value={updateData.remarks} />
                                                </div>
                                            </div>
                                            <div class="row mt-4 text-left">
                                                <div class="col-12" style={{ textAlign: 'end' }}>
                                                    <button
                                                        type="submit"
                                                        style={{
                                                            marginRight: "4px",
                                                            backgroundColor: "#5B489D",
                                                            color: "white",
                                                        }}
                                                    >
                                                        Update
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        style={{
                                                            marginRight: "4px",
                                                            backgroundColor: "white",
                                                            color: "#F15843",
                                                            border: "none",
                                                        }}
                                                    >
                                                        Reset
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    </Wrapper>

                </div>
            </div>
        </div>
    )
}

export default ExpenseDetail;

